import React, { useEffect, useState } from 'react';
import defaultPic from '../../../images/default-profile-picture.jpg'

const getViewportWidth = () => {
    if (typeof window === 'undefined' || typeof window.innerWidth === 'undefined') {
        return 1024;
    }
    return window.innerWidth;
};

const ProfileBadge = ({ selectedData, sessionData }) => {
    const [viewportWidth, setViewportWidth] = useState(getViewportWidth());

    useEffect(() => {
        const handleResize = () => setViewportWidth(getViewportWidth());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = viewportWidth <= 768;

    const containerStyle = {
        border: '1px solid #E1E1E1',
        borderRadius: '5px',
        minWidth: isMobile ? 'auto' : 305
    };

    return (
        <div
            className={`bg-white d-flex align-items-center p-2 border border-primary profileHeader ${isMobile ? 'profileHeader--mobile' : ''}`}
            style={containerStyle}
        >
            <img
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = defaultPic;
                }}
                src={selectedData?.image_url ?? defaultPic}
                alt="Profile"
                className="rounded-circle border border-success border-2 profileHeader__avatar"
                style={{ width: '50px', height: '50px' }}
            />
            <div className="profileHeader__details d-flex flex-column">
                <div className='d-flex flex-column'>
                    {(selectedData?.resource_first || selectedData?.resource_last) && (
                        <span className="text-uppercase fw-bold" style={{ fontSize: 12, color: '#141414' }}>
                            {`${selectedData?.resource_first ?? ''} ${selectedData?.resource_last ?? ''}`.trim()}
                        </span>
                    )}
                    <span className="text-capitalize text-secondary fw-normal" style={{ fontSize: 10, color: '#141414' }}>
                        {sessionData?.role_name}
                    </span>
                    <span className="text-capitalize text-secondary fw-normal" style={{ fontSize: 10, color: '#141414' }}>
                        {sessionData?.property_name}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ProfileBadge;
